export default __webpack_public_path__ + "static/media/no-content.9b4f8568.png";